import React, {
    useEffect,
    useLayoutEffect, useRef,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import Remove from 'assets/images/icon/Remove';
import useGetClassData from 'hooks/useGetClassData';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  useRecoilState,
  useSetRecoilState,
} from 'recoil';
import {
  activeSubmit,
  fireSubmit,
} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';

import PlusIcon from '../../../../../assets/images/icon/PlusIcon';
import useSetHashData from "../../../../../hooks/useSetHashData";
import hashIt from "hash-it";
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}

const Overview = () => {
    const location = useLocation();   
    const navigate = useNavigate();
    const { data:classesData, stepData } = useGetClassData(location?.state?.createId, "getClassOverviewById");
    const setSubmit = useSetRecoilState(activeSubmit);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);    
    const [description, setDescription] = useState("");
    const [objective, setObjective] = useState([""]);
    const [requirements, setRequirements] = useState([""]);
    const setArrayData = (state: any, method: string, setState: any, index: number) => {
        const data = cloneDeep(state);
        if (method === "add") {
            data.push("");
        } else {
            data.splice(index, 1);
        }

        setState([...data]);
    };

    const setLocalState = () => {

        if(!isEmpty(stepData)){
            const overviewData = cloneDeep(stepData);
            const learingObject = [...overviewData?.learningObject]
            const requirementsData = [...overviewData?.requirements]
            setDescription(overviewData?.description || "");
            setObjective(isEmpty(learingObject) ? [""] : learingObject); 
            setRequirements(isEmpty(requirementsData) ? [""] : requirementsData); 
        }
    };
    console.log('location.state', location.state)
    const putOverviewData = async (next?:any) => {
        if(isEmpty(location?.state?.createId)) return;
        await classesAPI.putClassOverview(location?.state?.createId, {
            data:{
                description:description,
                leaningObject:[...objective], // leaningObject, learningObject
                requirements:[...requirements]
            }
        })
        .then(res => {
            console.log('update overview', res);
            if(next == true){
                navigate("/create/learning material",{
                    state:{
                        createId:location?.state?.createId,
                    }
                })
            }
        })
        .catch(e => {
            console.log('failed', e)
        })
    }

    const onChange = (
        e: any,
        state: any,
        setState: any,
        index: number
    ) => {
        const data = cloneDeep(state);
        const value = e.target.value;
        data[index] = value;
        setState([...data])
    };
    const checkSubmitCondition = () => {        
        const objectiveCheck = objective.find((item) => isEmpty(item));
        const descriptionCheck = description?.length !== 0;
        const requirementsCheck = requirements?.find(item => isEmpty(item))
        return objectiveCheck === undefined &&  descriptionCheck && requirementsCheck === undefined
    };
    const h = hashIt({
        description:description,
        leaningObject:[...objective], // leaningObject, learningObject
        requirements:[...requirements]
    });
    const itemRef = useRef(null);
    const titleInputRef = useRef(null);

    useEffect(() => {
        titleInputRef?.current?.focus()
    }, [titleInputRef?.current]);
    useEffect(() => {
        itemRef.current = putOverviewData
        return () => {
            console.log("@h",h);
        }
    }, [h]);
    useEffect(() => {
        console.log("@h",h);
        return () =>{
            itemRef.current();
        }
    }, []);
    useLayoutEffect(()=>{
        if(stepData !== null){
            setLocalState();
        }
    },[stepData]);

    useEffect(() => {
        setSubmit(checkSubmitCondition());

    },[objective, description, requirements]);

    useEffect(()=>{
        if(submitFire === true){
            setSubmitFire(false)
            putOverviewData();
        }
    },[submitFire]);

    return (
        <Container>
            <Contents>
                <Row>
                    <FormBox>
                        <dt>
                            Class Description<strong>*</strong>
                        </dt>
                        <dd>
                            <FormBoxItemWrap>
                                <li>
                                    <FormItem style={{ width: "calc(100% - 53px)" }}>
                                        <textarea
                                            ref={titleInputRef}
                                            required={true}
                                            style={{ height: 100 }}
                                            placeholder="Describe something about your role and responsibilities in company"
                                            value={description}
                                            onChange={(
                                                e: React.ChangeEvent<HTMLTextAreaElement>
                                            ) => {
                                                setDescription(e.target.value);
                                            }}
                                            maxLength={1000}
                                        />
                                        <TextLength>{1000 - description.length}</TextLength>
                                    </FormItem>
                                </li>
                            </FormBoxItemWrap>
                        </dd>
                    </FormBox>
                </Row>
                <Row>
                    <dt style={{ marginBottom: 8 }}>
                        Learning objective<strong>*</strong>
                    </dt>
                </Row>
                {objective?.map((item, index) => {
                    return (
                        <Row style={{marginBottom:16}}>
                            <Col style={{ width: "100%" }}>
                                <FormItem
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: objective?.length === 1 ? "calc(100% - 53px)" : "100%",
                                    }}
                                >
                                    <input
                                        maxLength={300}
                                        required={true}
                                        type="text" value={item} onChange={(e: React.ChangeEvent<HTMLInputElement>)=>{
                                        onChange(e, objective, setObjective, index)
                                    }} placeholder="Enter objectives or outcomes that learners can expect to achieve after completing your class." />
                                    {objective?.length !== 1 && (
                                        <RemoveButton
                                            onClick={() => {
                                                setArrayData(
                                                    objective,
                                                    "remove",
                                                    setObjective,
                                                    index
                                                );
                                            }}
                                            style={{ marginLeft: 21 }}
                                        >
                                            <Remove />
                                        </RemoveButton>
                                    )}
                                    <TextLength
                                        className={objective?.length !== 1 ? "in" : ""}
                                    >{300 - objective[index]?.length}</TextLength>
                                </FormItem>
                            </Col>
                        </Row>
                    );
                })}

                <AddChapter
                    onClick={() => {
                        setArrayData(objective, "add", setObjective, 0);
                    }}
                >
                    <span>Add</span>
                    <PlusIcon />
                </AddChapter>

                <Row>
                    <dt style={{ marginBottom: 8}}>
                        Requirements<strong>*</strong>
                    </dt>
                </Row>
                {requirements?.map((item, index) => {
                    return (
                        <Row
                            style={{marginBottom:16}}
                        >
                            <Col style={{ width: "100%" }}>
                                <FormItem
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: requirements?.length === 1 ? "calc(100% - 53px)" : "100%",
                                    }}
                                >
                                    <input required={true} type="text" value={item} onChange={(e: React.ChangeEvent<HTMLInputElement>)=>{
                                        onChange(e, requirements, setRequirements, index)                                        
                                    }} placeholder="List the skills, experience, tools or equipment learners need in order to take your class" />
                                    {requirements?.length !== 1 && (
                                        <RemoveButton
                                            onClick={() => {
                                                setArrayData(
                                                    requirements,
                                                    "remove",
                                                    setRequirements,
                                                    index
                                                );
                                            }}
                                            style={{ marginLeft: 21 }}
                                        >
                                            <Remove />
                                        </RemoveButton>
                                    )}
                                    <TextLength
                                        className={requirements?.length !== 1 ? "in" : ""}
                                    >{300 - requirements[index]?.length}</TextLength>
                                </FormItem>
                            </Col>
                        </Row>
                    );
                })}

                <AddChapter
                    style={{
                        marginTop:16,
                        marginBottom:8
                    }}
                    onClick={() => {
                        setArrayData(requirements, "add", setRequirements, 0);
                    }}
                >
                    <span>Add</span>
                    <PlusIcon />
                </AddChapter>
            </Contents>
            <ButtonItems justifyContent={"space-between"}>
                <Browse
                    className={"prev"}
                    onClick={async ()=>{
                        await putOverviewData(false)
                        navigate("/create/details",{
                            state:{
                                createId:location?.state?.createId,
                            }
                        })
                    }}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0 }}>Previous</span>
                </Browse>
                <button
                    className={`${checkSubmitCondition() ? "on" : ""} continue`}
                    onClick={async ()=>{ await putOverviewData(true)}}
                >Continue</button>
            </ButtonItems>
        </Container>
    );
};
export default Overview;

const Container = styled.div`
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    //overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom:8px;
    strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    dt{
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        
    }
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
`;

const FormBox = styled.dl`

    > dt {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        margin-bottom: 8px;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;

const FormItem = styled.div`
    @media screen and (max-width: 768px) {
        width: 100% !important;
    }
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 40px 12px 16px;
        &:focus{
            border: solid 2px #333;
        }
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
    &.in{
        right: 60px;
        @media screen and (max-width: 768px) {
          right: 40px;
        }
    }
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: ${(props) => props.justifyContent};
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    
    button {
        &.continue{
                font-family: Europa-Regular;
                font-size: 18px;
                font-weight: 400;
                line-height: 18px;
                text-align: left;
                border: solid 1px #ddd;
        }
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddd;
        pointer-events: none;
        border: solid 1px #333;
        &.on{
             background: #333;
             color: #fff;
             pointer-events: all;
            border: solid 1px #333;
            &:hover{
                background: #fff;
                color: #333;
            }
        }
    }
`;
const Browse = styled.div`
    position: relative;
    transition: all 0.2s;
    cursor: pointer;
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    max-width: 120px;
    &.prev{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &.add{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    &:hover{
        background: #333;
        border-color: #333;
        span{
            color: #fff!important;
        }

        svg{
            path{
                fill: #fff!important;
            }
        }
        span{
            color: #fff;

        }
    }
    @media screen and (max-width: 768px) {
        width: 100%!important;
        min-width: 100%;
        max-width: 100%;
        min-height: 46px;
        &.prev{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
        }
        &.add{
            min-width: 95px;
            max-width: 95px;
            min-height: 40px;
            height: 40px;
        }
    }
    span {
        margin-left: 10px;
        font-size: 18px;
        color: #333;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    svg{
        width: 16px;
        height: 16px;
        path{
            fill: #333!important;
        }
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
`;
const RemoveButton = styled.div`
    //transition: all 0.3s;
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px rgba(51, 51, 51, 0);
    border-radius: 50%;
    cursor: pointer;
    &:hover {
        border: solid 1px #333;
        border-radius: 50%;

        svg {
            transition: all 0.3s;
            color: #333 !important;
            stroke: #333 !important;

            path {
                fill: #333 !important;
                opacity: 1 !important;
                fill-opacity: 1;
            }
        }
    }

    @media screen and (max-width: 768px) {

        margin-left: 10px !important;
        div & {
        }
        width: 20px;
        height: 20px;
        svg {
            width: 20px;
        }
    }
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 8px;
    margin-top: 15px;
    cursor: pointer;
    transition: all 0.2s;
    border: solid 1px #333;
    &:hover{
        background: #fff;
        border-color: #333;
        svg{
            path{
                fill: #333;
            }
        }
        span{
            color: #333;
            cursor: default;
        }
    }
    span {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
    }
`;
